document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('.header')) {
        const logo = document.querySelector('.header__logo');

        logo.addEventListener('click', (e) => {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
  });